import {mapState} from "vuex";
export default {
    name: "meeting-dayview",
    data() {
        return {
            cell_width: 100,
            target: null,
            books: {},
            tencent:{},
            welink:{},
            header_left: 0,
            platform:'zoom',
            today:'',
        }
    },
    created() {
        this.target = new Date().Format('yyyy-MM-dd');
        if (this.hasZoom) this.platform = 'zoom';
        else if (this.hasTencent) this.platform = 'tencent';
        else if (this.hasWelink) this.platform = 'welink';
        this.today = new Date().Format('yyyy-MM-dd');
    },
    mounted() {
        this.reload();
    },
    computed: {
        ...mapState(['process','preset']),
        hasZoom(){
            const groups = this.preset.app.room_groups;
            if( !groups ) return false;
            for(let i=0;i<groups.length;i++) {
                if (['0','2','3'].includes(groups[i].platform + '')) return true;
            }
            return false;
        },
        hasTencent(){
            const groups = this.preset.app.room_groups;
            if( !groups ) return false;
            for(let i=0;i<groups.length;i++) {
                if ((groups[i].platform + '') === '1') return true;
            }
            return false;
        },
        hasWelink(){
            const groups = this.preset.app.room_groups;
            if( !groups ) return false;
            for(let i=0;i<groups.length;i++) {
                if ((groups[i].platform + '') === '4') return true;
            }
            return false;
        },
        calendarWidth() {
            return this.cell_width * 24 + 'px';
        },
        ruleCells() {
            let ret = [];
            for (let i = 0; i < 24; i++) {
                ret.push(('0' + i).substr(-2));
            }
            return ret;
        },
        meetingRooms() {
            let ret = [];
            for (let key in this.books) {
                const item = this.books[key];
                ret.push(item.room);
            }
            return ret;
        }
    },
    methods: {
        next() {
            let date = this.$dateParse(this.target);
            date.setDate(date.getDate() + 1);
            this.target = date.Format('yyyy-MM-dd');
            this.reload();
        },
        previous() {
            let date = this.$dateParse(this.target);
            date.setDate(date.getDate() - 1);
            this.target = date.Format('yyyy-MM-dd');
            this.reload();
        },
        reload() {
            if (this.$is_date(this.target)) {
                this.$api('Query.View.Day', {date: this.target}, true).then(res => {
                    this.books = res.data.data.books;
                    this.tencent = this.beautifyMeeting(res.data.data.tencent);
                    this.welink = this.beautifyMeeting(res.data.data.welink);
                });
            }
        },
        beautifyMeeting(meetings) {
            let ret = {};
            if (!Array.isArray(meetings) || meetings.length === 0) return ret;
            for (let i = 0; i < meetings.length; i++) {
                // Clone the item to avoid mutating the original array
                const item = Object.assign({}, meetings[i]);
                item.start = this.$dateTimeParse(item.meeting_date + ' ' + item.meeting_time);
                const duration = item.duration; // 会议时长(分钟)
                item.end = item.start + duration* 60; // 会议结束时间(秒)
            
                let target = -1;
                for (let j in ret) {
                    const layer = ret[j].reserves; //每一层都检查一下是否有空的地方可以存放
                    let conflict = false;
                    for (let k = 0; k < layer.length; k++) { // 每一层的会议列表拿出来比对
                        const meeting = layer[k];
                        if (item.end >= meeting.start && meeting.end >= item.start) {
                            conflict = true;
                            break;
                        }
                    }
                    if (!conflict) { //找到了j
                        target = j;
                        break;
                    }
                }
                if (target === -1) { //新加
                    target = Object.keys(ret).length;
                    ret[target] = {};
                    ret[target]['reserves'] = [item];
                } else {
                    ret[target]['reserves'].push(item);
                }
            }
            console.log('ret', ret);
            return ret;
            
        },
        calcPosition(date, start, duratin) {
            let left = 0, width = 0;
            if (date == this.target) {
                if (typeof start === 'string') {
                    const arr = start.split(':');
                    const hour = parseInt(arr[0]) + (arr[1] === '00' ? 0 : 0.5);
                    left = hour * this.cell_width;
                }
                 width = parseInt(duratin) / 60 * this.cell_width;
            } else {
                let diff = 0;
                if (typeof start === 'string') {
                    const arr = start.split(':');
                    const hour = parseInt(arr[0]) + (arr[1] === '00' ? 0 : 0.5);
                    diff = (24 - hour) * this.cell_width;
                }
                width = parseInt(duratin) / 60 * this.cell_width - diff;
            }
            if (left + width > this.cell_width * 24) width = this.cell_width * 24 - left;
            return {left: left + 'px', width: width + 'px'}
        },
        syncHeader(e) {
            this.header_left = e.target.scrollLeft;
            this.$refs['headerRule'].scrollLeft = this.header_left;
            this.$refs['bodyContent'].scrollLeft = this.header_left;
        }
    }
}
